import script from "./BaseLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLoading.vue?vue&type=script&setup=true&lang=js"

import "./BaseLoading.vue?vue&type=style&index=0&id=3d2b32ab&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2b32ab"]])

export default __exports__